import { notify } from '@billy/design-system'
import { TFunction } from 'i18next'

import { NotificationKeys } from '../../../enums/notificationKeys'

export const notifyPaymentRegistrationError = (t: TFunction, message?: string) =>
  notify({
    id: NotificationKeys.BillReconciliationError,
    message: message || t('application_error.unknown_error'),
    variant: 'error',
  })
